var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgErrorBig(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 104,
    height: 104,
    viewBox: "0 0 104 104",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#d8284a;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-73 -73)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M125,177a51.8,51.8,0,1,1,20.243-4.087A51.645,51.645,0,0,1,125,177Zm0-100.446A48.446,48.446,0,1,0,173.446,125,48.5,48.5,0,0,0,125,76.554Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 44,
    height: 4,
    transform: "translate(108.029 139.142) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 44,
    height: 4,
    transform: "translate(139.142 141.971) rotate(-135)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgErrorBig);
export default __webpack_public_path__ + "static/media/error-big.8d1c704f823b29d97dd13885e0e491de.svg";
export { ForwardRef as ReactComponent };